import axios from 'axios';
import {Message,Loading} from "element-ui";
import {updateTK} from "@/api/mxbc";


// 基本配置
const instance = axios.create({
    //xyk.zhpet.vip
    baseURL: 'https://xyk.zhpet.vip', // 根据实际情况修改API地址
    timeout: 30000 // 设置超时时间，单位为ms
});

// 存储取消令牌的对象，用于全局请求取消
const cancelTokens = {};

// 请求拦截器
instance.interceptors.request.use(config => {
    let cardID = localStorage.getItem('cardID')

    config.headers = {
        ...config.headers, // 保留已有的请求头
        'Content-Type': 'application/json', // 设置 Content-Type
    };

    if (config.method === 'post' && cardID) {
        // 添加默认参数
        config.data = {
            ...config.data, // 保留已有的参数
            cardID
        };
    }

    const requestId = config.url; // 使用请求 URL 作为请求 ID（简单示例，实际可能需要更复杂的逻辑）
    if (!cancelTokens[requestId]) {
        cancelTokens[requestId] = axios.CancelToken.source();
        config.cancelToken = cancelTokens[requestId].token;
    }

    // if (cardID) {
    //     //if (config.url == '/api/Card/Query') return config;
    //     config.url = config.url + '?cardID=' + cardID
    // }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use(response => {
    // 对响应数据进行处理
    // 例如：移除已完成的请求的取消令牌
    const requestId = response.config.url;
    if (cancelTokens[requestId]) {
        delete cancelTokens[requestId];
    }

    if (response.data.code !== 0) {
        if (!response.data.msg.includes('重新登录')) {
            Message({
                message: response.data.msg,
                type: 'error'
            })
        }

        if (response.data.msg.includes('重新登录')){
            const loading = Loading.service({
                lock: true,
                text: '正在刷新token...',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            updateTK({cardID:localStorage.getItem('cardID')}).then(res=>{
                loading.close();
                if (res.code === 0){
                    location.reload();
                }
            }).catch(() => {
                loading.close();
            }).finally(() => {
                loading.close();
            })
        }
    }
    return response.data;
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    // 响应错误处理
    // 例如：处理取消的请求
    if (axios.isCancel(error)) {
        console.log('Request cancelled:', error.message);
    } else {
        // 其他错误处理
        console.error('Request failed:', error);
    }
    // 移除被取消或失败的请求的取消令牌
    const requestId = error.config?.url;
    if (requestId && cancelTokens[requestId]) {
        delete cancelTokens[requestId];
    }
    return Promise.reject(error);
});

export default instance;
